import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { BANK_ACCOUNT_PATH } from '../../../../config/paths';
import BankAccountDeleteButton from './BankAccountDeleteButton';

const BankToolbar = ({ bankAccountId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${BANK_ACCOUNT_PATH}/${bankAccountId}/edit`} />{' '}
      <BankAccountDeleteButton bankAccountId={bankAccountId} />
    </div>
  </ButtonToolbar>
);

BankToolbar.propTypes = {
  bankAccountId: PropTypes.number.isRequired,
};

export default BankToolbar;
